import { Box } from '@mui/material';

export const StackSpacer = () => {
  return <Box flexGrow={1} />;
};
